import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IAnchorCompIdProvider, ScrollToAnchorPageConfig } from '../types'
import { name } from '../symbols'

const anchorDataItCompIdProviderFactory = ({
	anchorDataIdToCompIdMap,
}: ScrollToAnchorPageConfig): IAnchorCompIdProvider => {
	return {
		getAnchorCompId: (anchorDataId) => anchorDataIdToCompIdMap[anchorDataId],
	}
}

export const AnchorDataItCompIdProvider = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	anchorDataItCompIdProviderFactory
)
